import { ImageBackground, ImageBackgroundProps } from 'expo-image';
import { StyleSheet } from 'react-native';

import { YStack } from '@fhs/ui';
import { useClickLogs } from '@fhs-legacy/frontend/src/hooks/use-click-logs';

import { CtaButton } from '../shared/cta-button';

export type CareersCardProps = Omit<ImageBackgroundProps, 'children' | 'source'> & {
  careersHref: string;
};
export function CareersCard({ careersHref, ...props }: CareersCardProps) {
  const { logCareersCardClickEvent } = useClickLogs();
  return (
    <ImageBackground
      source={require('./careers-card-background.webp')}
      placeholder={{ thumbhash: '1ygKF4IXd4Zgi5eYdZmXGIebaCC3I4MP' }}
      alt="Careers. Help us fuel the future"
      {...props}
      style={[styles.careersCard, props.style]}
    >
      <YStack style={styles.container}>
        <CtaButton href={careersHref} text="Work With Us" onPress={logCareersCardClickEvent} />
      </YStack>
    </ImageBackground>
  );
}

const styles = StyleSheet.create({
  careersCard: {
    aspectRatio: 2030 / 1905,
    width: '50%',
  },
  container: {
    position: 'absolute',
    top: '60%',
    left: 0,
    right: 0,
    alignItems: 'center',
  },
});
